<template>
  <div>
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        :size="size"
      >
        <el-form-item label="订单状态">
          <el-select
            v-model="filters.status"
            clearable
            placeholder="请选择订单状态"
            @visible-change="handleVisibleChange"
          >
            <el-option
              v-for="item in orderStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专家姓名">
          <el-input v-model="filters.proName" clearable placeholder="请选择专家姓名"></el-input>
        </el-form-item>
        <el-form-item label="工单编号">
          <el-input v-model="filters.orderNo" clearable placeholder="请填写工单编号"></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-search" label="查询" type="primary" @click="onSubmit" />
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-plus" label="新增" type="warning" @click="handleAdd" />
        </el-form-item>
      </el-form>
      <div class="filtersposition"></div>
    </el-scrollbar>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
        @expand-change="expandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="订单状态：">
                <span class="height40">{{ props.row.statusText }}</span>
              </el-form-item>
              <el-form-item label="订单剩余有效天数：">
                <span class="height40">{{ props.row.validDays }}</span>
              </el-form-item>
              <el-form-item label="工单编号：">
                <span class="height40">{{ props.row.orderNo }}</span>
              </el-form-item>
              <el-form-item label="专家姓名：">
                <span class="height40">{{ props.row.specialistName }}</span>
              </el-form-item>
              <el-form-item label="专家是否在线：">
                <span class="height40">{{ props.row.isPutaway }}</span>
              </el-form-item>
              <el-form-item label="服务地址：" v-if="props.row.orderType == 2">
                <span class="height40">{{ props.row.serviceAddress }}</span>
              </el-form-item>
              <el-form-item label="服务老人：" v-else>
                <span class="height40">{{ props.row.oldName }}</span>
              </el-form-item>
              <el-form-item label="服务项目：">
                <!-- {{'(' + props.row.merchandiseName + ')'}} -->
                <span class="height40">{{ serverList[props.row.orderType] }}</span>
                <span v-if="props.row.orderType == 2">{{'(' + props.row.merchandiseName + ')'}}</span>
              </el-form-item>
              <el-form-item label="服务金额:">
                <span v-if="props.row.orderType == 0" class="height40">{{ props.row.total }}元/次</span>
                <span v-else-if="props.row.orderType == 1" class="height40">
                  {{ props.row.total }}元/
                  <span
                    v-if="props.row.numberMonthly != 0"
                  >{{props.row.numberMonthly}}次/</span>月
                </span>
                <span v-else class="height40">
                  {{ props.row.total }}元/
                  <span
                    v-if="props.row.residueNumber != 0"
                  >{{props.row.residueNumber}}次/</span>月
                </span>
              </el-form-item>
              <el-form-item label="备注：">
                <span class="height40">{{ props.row.remark?props.row.remark:'无备注' }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" align="center" min-width="80">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column prop="statusText" label="订单状态" min-width="120" align="center"></el-table-column>
        <el-table-column prop="validDays" label="订单剩余有效天数" min-width="120" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="工单编号" min-width="180" align="center"></el-table-column>
        <el-table-column prop="specialistName" label="专家姓名" min-width="150" align="center"></el-table-column>
        <el-table-column prop="isPutaway" label="专家是否在线" min-width="150" align="center"></el-table-column>
        <el-table-column label="操作" min-width="200" align="center">
          <template slot-scope="scope">
            <div style="display:flex;justify-content:center;">
              <el-button
                :disabled="scope.row.orderStatus!=3||scope.row.orderType!=2"
                size="mini"
                plain
                type="success"
                @click="handlesure(scope.row)"
              >确认</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </el-row>

    <!-- 新增工单 -->
    <el-dialog
      title="新增工单"
      :visible.sync="addOrderDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="closeAddDialog"
    >
      <el-form ref="dataForm" :model="dataForm" :rules="dataFormRules" label-width="150px">
        <el-form-item label="老人姓名:" prop="oldmanName">
          <el-autocomplete
            v-model.trim="dataForm.oldmanName"
            auto-complete="off"
            placeholder="模糊搜索老人姓名"
            style="width:80%"
            :fetch-suggestions="querySearchAsync"
            @select="handleOlderSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号码:">
          <span class="height40">{{orderInfo.oldIdCard}}</span>
        </el-form-item>
        <el-form-item label="电话号码:">
          <span class="height40">{{orderInfo.oldPhone}}</span>
        </el-form-item>
        <el-form-item label="监护人:">
          <span class="height40">{{orderInfo.egNamea}}</span>
        </el-form-item>
        <el-form-item label="服务地址:" prop="serviceAddress">
          <el-input
            v-model.trim="dataForm.serviceAddress"
            placeholder="选择服务地址"
            style="width:80%"
            @focus="focusServiceAddress"
          ></el-input>
        </el-form-item>
        <el-form-item label="工单来源:" prop="orderSource">
          <span class="height40">电话预约</span>
        </el-form-item>
        <el-form-item label="选择服务项目:" prop="serviceId" required>
          <el-select
            class="serviceDesc"
            v-model="dataForm.serviceId"
            @change="changeSecondServer"
            style="width:80%"
            placeholder="请选择服务项目"
          >
            <el-option
              v-for="item in secondServerList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择商品/服务:" prop="goodId" required>
          <el-select
            v-model="dataForm.goodId"
            @change="changeGood"
            style="width:80%"
            placeholder="请选择商品/服务"
          >
            <el-option v-for="item in dataList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算金额:">
          <span class="height40">{{dataForm.settlementAmount}}元</span>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="dataForm.remark" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="addOrderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddOrderForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 确认订单 -->
    <el-dialog
      class="dialog"
      title="确认订单"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="closeDialogReset"
    >
      <el-form ref="doctorForm" :model="doctorForm" :rules="doctorFormRules" label-width="100px">
        <el-form-item label="请指派专家">
          <el-select v-model="doctorForm.specialistName" placeholder="请选择">
            <el-option
              v-for="item in doctorList"
              :key="item.id"
              :label="item.specialistName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="closeDialog">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 家庭地址设置 -->
    <el-dialog
      class="el-dialog-map"
      title="家庭住址设置"
      :visible.sync="dialogFormVisibleSafe"
      @close="closeMap"
    >
      <el-input
        v-model="keyword"
        style="position:absolute;left:100px;top:90px;z-index:999"
        class="fix-width"
      ></el-input>
      <div class="oldmanmap" style="position:relative;">
        <baidu-map
          class="map"
          :center="center"
          :zoom="zoom"
          @ready="handler"
          :scroll-wheel-zoom="true"
          :mapStyle="mapStyle"
          :mapType="mapType"
          @click="getPoint"
        >
          <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
          <bm-map-type
            :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
            anchor="BMAP_ANCHOR_TOP_RIGHT"
          ></bm-map-type>
          <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="true"></bm-overview-map>
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
          <bm-local-search
            id="bm-local-search"
            :keyword="keyword"
            :auto-viewport="true"
            @markersset="markersset"
            @infohtmlset="infohtmlset"
            style="width:250px;heiught:300px;position:absolute;left:-270px;top:-90px;z-index:999;display:block;"
            zoom="14.8"
          ></bm-local-search>
          <!--信息窗口，show属性是控制显示隐藏，infoWindowClose和infoWindowOpen是控制信息窗口关闭隐藏的方法-->
          <bm-marker :position="postionMap">
            <bm-info-window
              :show="showMark"
              @close="infoWindowClose"
              @open="infoWindowOpen"
              style="font-size: 14px"
            >
              <p>站点：{{ add.siteName }}</p>
              <p>站点地址：{{ add.site }}</p>
            </bm-info-window>
          </bm-marker>
          <bm-marker :position="postionHuiXian">
            <bm-info-window :show="showMarkHuiXian" style="font-size: 14px"></bm-info-window>
          </bm-marker>
        </baidu-map>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="sureMap">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  components: { KtButton },
  data() {
    return {
      size: "medium",
      orderStatusList: [
        { label: "已下单", value: 0 },
        { label: "咨询待回复", value: 1 },
        { label: "咨询已回复 ", value: 2 },
        { label: "订单待确认", value: 3 },
        { label: "订单生效中", value: 4 },
        { label: "订单已过期", value: 5 },
        { label: "订单次数已完成", value: 6 }
      ], //订单的状态
      serverList: ["咨询订单", "远程视频订单", "远程监测订单"],
      filters: {
        orderNo: "",
        status: "",
        proName: ""
      },
      dialogVisible: false,
      editLoading: false, //修改loading
      putAwayList: ["在线", "离线"],
      doctorList: [],
      secondServerList: [
        { label: "咨询订单", value: 0 },
        { label: "远程视频订单", value: 1 },
        { label: "远程监测订单", value: 2 }
      ],
      dataList: [],
      tableData: [],
      doctorForm: {
        specialistName: ""
      },
      doctorFormRules: {
        specialistName: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        remark: [{ min: 0, max: 50, message: "长度在 0到 50 个的字符" }]
      },
      expands: [], //表格展开的id集合
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      total: 0, //数据的总数,
      groupId: "", //机构id
      merchantId: "", //商家id
      orderId: "", //订单id

      //新增订单的dialog模态框配置
      addOrderDialogVisible: false,
      dataForm: {
        oldmanId: "",
        oldmanName: "",
        oldIdCard: "",
        oldPhone: "",
        relationshipa: "",
        serviceAddress: "",
        serviceId: "",
        goodId: "",
        good: "",
        time: "",
        remark: "",
        oldAddressBdGps: "",
        settlementAmount: 0
      },
      useOrderInfo: {
        userIdPut: "",
        userNamePut: "",
        userPhone: ""
      },
      orderInfo: {},
      multipleSelection: [],
      dataFormRules: {
        oldmanName: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        serviceAddress: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        serviceId: [
          {
            required: true, //是否必填
            message: "不能为空" //规则
          }
        ],
        goodId: [{ required: true, message: "不能为空" }],
        remark: [{ min: 0, max: 50, message: "长度在 0到 50 个的字符" }]
      },

      //服务地址地图配置
      keyword: "", //模糊搜索
      oldmanId: "", //老人的id,用于请求数据获取老人的百度经纬度
      oldmanlng: "", //经度
      oldmanlat: "", //纬度
      postionMap: { lng: 0, lat: 0 }, //点击获取经纬度
      postionHuiXian: { lng: 0, lat: 0 }, //回显的经纬度坐标
      add: { jd: "", wd: "", siteName: "", site: "" }, //添加的mark
      showMark: false, //Mark点显示隐藏
      showMarkHuiXian: false, //修改回显mark点的提示
      dialogFormVisibleSafe: false, //选择老人的家庭住址的模态框
      center: { lng: 0, lat: 0 }, //中心点
      zoom: 3, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: {
              hue: "#007fff",
              saturation: 89
            }
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#ffffff"
            }
          }
        ]
      },
      BMap: "",
      map: ""
    };
  },
  methods: {
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: left;font-size: 16px;background-color: #efefef;";
      }
    },
    /* 
      查询按钮查询
    */
    onSubmit() {
      this.queryList((this.pageNum = 1), (this.pageSize = 10));
    },

    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      //console.log('回车搜索', keyCode, e)
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryList((this.pageNum = 1), (this.pageSize = 10));
      }
    },

    /* 
      获取表格展开的id
    */
    getRowKeys: function(row) {
      return row.id;
    },

    /* 
      展开和关闭表格的事件
    */
    expandChange(row, expandedRows) {
      //console.log(row, expandedRows, 'defiiefigi')
      // this.queryMerchantDetail(row.id);
      if (expandedRows.length) {
        this.expands = [];
        if (row) {
          this.expands.push(row.id);
        }
      } else {
        this.expands = [];
      }
    },

    /* 
      分页查询列表
    */
    queryList() {
      let params = new Object();
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      if (this.filters.status != "") {
        params.orderStatusList = [this.filters.status];
      } else if (this.filters.status == "0") {
        params.orderStatusList = [this.filters.status];
      }
      if (this.filters.proName != "") {
        params.specialistName = this.filters.proName;
      }
      if (this.filters.orderNo != "") {
        params.orderNo = this.filters.orderNo;
      }
      params.groupId = this.groupId;
      this.$postJson("omc/longRangeServiceOrder/select", params).then(res => {
        this.tableData = [];
        if (res.code == 200) {
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.total = res.result.total * 1;
            res.result.list.forEach(item => {
              let object = {};
              object = Object.assign({}, item);
              object.serviceAddressText = item.serviceAddress;
              if (item.orderType == 2) {
                switch (item.orderStatus) {
                  case 0:
                    object.statusText = "已下单";
                    break;
                  case 3:
                    object.statusText = "订单待确认";
                    break;
                  case 4:
                    object.statusText = "订单生效中";
                    break;
                  case 5:
                    object.statusText = "订单已过期";
                    break;
                  case 6:
                    object.statusText = "订单次数已完成";
                    break;
                }
              } else {
                switch (item.orderStatus) {
                  case 0:
                    object.statusText = "已下单";
                    break;
                  case 1:
                    object.statusText = "咨询待回复";
                    break;
                  case 2:
                    object.statusText = "咨询已回复";
                    break;
                  case 3:
                    object.statusText = "远程视频订单待确认";
                    break;
                  case 4:
                    object.statusText = "远程视频订单生效中";
                    break;
                  case 5:
                    object.statusText = "远程视频订单已过期";
                    break;
                  case 6:
                    object.statusText = "远程视频订单次数完成";
                    break;
                }
              }

              switch (item.isPutaway) {
                case 0:
                  object.isPutaway = "在线";
                  break;
                case 1:
                  object.isPutaway = "离线";
                  break;
              }
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },

    deleteMerchantName() {
      this.filters.proName = "";
    },

    /* 
      获取专家列表
    */
    queryDoctorList() {
      let params = {
        groupId: this.groupId,
        pageSize: 999
      };
      //console.log(params)
      this.$postJson("omc/specialist/select", params).then(res => {
        //console.log(res, '查询专家列表')
        this.doctorList = res.result.list;
        //console.log(this.doctorList)
        this.dialogVisible = true;
      });
    },

    /* 
      确认订单弹出dialog模态框
    */
    handlesure(row) {
      //console.log(row)
      this.orderId = row.id;
      this.queryDoctorList();
    },

    //提交表单数据
    submitForm() {
      this.$refs.doctorForm.validate(valid => {
        if (valid) {
          let params = new Object();
          params.specialistId = this.doctorForm.specialistName;
          params.orderId = this.orderId;
          this.$postJson(
            "omc/longRangeServiceOrder/superviseEnter",
            params
          ).then(res => {
            //console.log(res)
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.dialogVisible = false;
            this.queryList();
            this.doctorForm.specialistName = "";
          });
        }
      });
    },

    //关闭dialog清除验证
    closeDialogReset() {
      this.$refs.doctorForm.resetFields(); //移除校验结果并重置字段值
    },

    //新增工单
    handleAdd() {
      this.addOrderDialogVisible = true;
      this.dataForm = {
        oldmanId: "",
        oldmanName: "",
        oldIdCard: "",
        oldPhone: "",
        relationshipa: "",
        serviceAddress: "",
        serviceId: "",
        goodId: "",
        time: "",
        remark: "",
        oldAddressBdGps: "",
        settlementAmount: 0
      };
      this.multipleSelection = [];
      (this.orderInfo = {}),
        this.$nextTick(() => {
          if (this.$refs.dataForm != undefined) {
            this.$refs.dataForm.resetFields();
          }
        });
    },

    /* 
      模糊搜索老人
    */
    querySearchAsync(queryString, cb) {
      //根据 queryString 搜索
      var list = [{}];
      var param = {
        pageNo: "0",
        pageSize: "0",
        oldName: queryString,
        // statusList: [1, 2, 3, 10],
        statusList: [3],
        groupId: this.groupId
      };
      //statusList老人状态的数组,可以查询不同状态的老人
      //老人状态 0-未入院 1-待评估 2-待缴费 3-已入院 4-已出院 5-试入住 6-去世 7-请假中 8-调房调级中 9-出院中 10-app用户 11-已初评 12-待审批
      this.$postJson("omc/Oldman/listPage", param).then(res => {
        //console.log(res)
        if (res.result.list && res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
          //console.log(this.dataForm.oldmanName, 'jdjwjfjjfje')
          if (
            this.dataForm.oldmanName == "" ||
            this.dataForm.oldmanName == undefined ||
            this.dataForm.oldmanName == null
          ) {
            //console.log('进来了')
            this.deleteOldmanInfo();
          }
        } else {
          //console.log('没有搜索到老人')
          let arr = [];
          arr.push({
            uuid: "-1",
            value: ""
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldmanName = "";
            this.deleteOldmanInfo();
          }, 1000);
        }
      });
    },

    /* 
      选择老人
    */
    handleOlderSelect(item) {
      //console.log(item)
      this.dataForm.oldmanId = item.oldmanId;
      this.dataForm.serviceAddress = item.oldAddress;
      this.dataForm.detailedAddress = item.oldAddress;
      if (item.oldAddressBdGps != "") {
        var gps = item.oldAddressBdGps.split(",");
        this.dataForm.longitude = gps[0];
        this.dataForm.latitude = gps[1];
      }
      this.dataForm.oldAddressBdGps = item.oldAddressBdGps;
      this.orderInfo.oldIdCard = item.oldIdCard;
      this.orderInfo.oldPhone = item.oldPhone;
      this.orderInfo.egNamea = item.egNamea;
      this.orderInfo.relationshipa = item.relationshipa;
      this.orderInfo.egPhonea = item.egPhonea;
    },

    /* 
      获取登录用户的信息
    */
    getUserData() {
      this.$postForm("omc/group/getUserLongDetail", {}).then(response => {
        //console.log(response, 'response')
        this.useOrderInfo.userIdPut = response.result.userId;
        this.useOrderInfo.userNamePut = response.result.userName;
        this.useOrderInfo.userPhone = response.result.phone;
      });
    },

    /* 
      清空回显老人信息的数据    
    */
    deleteOldmanInfo() {
      this.$set(this.orderInfo, "oldIdCard", "");
      this.$set(this.orderInfo, "oldPhone", "");
      this.$set(this.orderInfo, "egNamea", "");
      this.$set(this.orderInfo, "relationshipa", "");
      this.$set(this.orderInfo, "egPhonea", "");
    },

    /*
      选择服务项目
    */
    changeSecondServer(e) {
      console.log(e);
      this.dataForm.goodId = " ";
      this.dataForm.settlementAmount = 0;
      if (e != this.secondServerList[2].value) {
        let params = {
          groupId: this.groupId,
          pageSize: 999
        };
        this.$postJson("omc/specialist/select", params).then(res => {
          //console.log(res, '查询专家列表')
          var list = [];
          res.result.list.forEach(item => {
            if (e == 0) {
              // cons
              list.push({
                id: item.id,
                name: item.specialistName,
                price: item.consultPrice,
                unit: 1
              });
            } else {
              //1 video
              list.push({
                id: item.id,
                name: item.specialistName,
                price: item.videoPrice,
                unit: 1
              });
            }
          });
          this.dataList = list;
          //console.log(this.dataList)
        });
      } else {
        let param = {
          pageNum: 1,
          pageSize: 999,
          secondLevelId: Number(e)
        };
        this.$postJson("omc/merchandis/selectByBackstage", param).then(res => {
          //console.log(res, '查询商品列表')
          var list = [];
          res.result.list.forEach(item => {
            if (item.isPutaway == 0) {
              if (item.serviceNumber == 0) {
                list.push({
                  id: item.id,
                  name: item.merchandiseName,
                  price: item.unitPrice,
                  unit: item.unit
                });
              } else {
                list.push({
                  id: item.id,
                  name: item.merchandiseName,
                  price: item.unitPrice,
                  unit: 1
                });
              }
            }
          });
          this.dataList = list;
        });
      }
    },

    /*
      选择商品
    */
    changeGood(e) {
      //console.log(e)
      //console.log(this.dataList)
      this.dataList.forEach(item => {
        if (e == item.id) {
          this.dataForm.settlementAmount = item.price * 1;
        }
      });
      // this.dataList=[];
    },

    /* 
      新增订单提交数据
    */
    submitAddOrderForm() {
      if (this.dataForm.serviceId == 0) {
        //咨询
        this.$refs.dataForm.validate(valid => {
          if (valid) {
            if (
              this.dataForm.goodId == null ||
              this.dataForm.goodId == "" ||
              this.dataForm.goodId == " "
            ) {
              this.$message({ message: "请选择商品", type: "error" });
              return;
            }
            let params = {};
            params.olamanId = this.dataForm.oldmanId;
            params.specialistId = this.dataForm.goodId;
            params.remark = this.dataForm.remark;
            this.$postJson(
              "omc/longRangeServiceOrder/consultPlaceAnOrder",
              params
            ).then(res => {
              //console.log(res)
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.addOrderDialogVisible = false;
              this.queryList();
            });
          }
        });
      } else if (this.dataForm.serviceId == 1) {
        //远程视频
        this.$refs.dataForm.validate(valid => {
          if (valid) {
            if (
              this.dataForm.goodId == null ||
              this.dataForm.goodId == "" ||
              this.dataForm.goodId == " "
            ) {
              this.$message({ message: "请选择商品", type: "error" });
              return;
            }
            let params = {};
            params.olamanId = this.dataForm.oldmanId;
            params.specialistId = this.dataForm.goodId;
            params.numbers = 1;
            params.remark = this.dataForm.remark;
            this.$postJson(
              "omc/longRangeServiceOrder/videoPlaceAnOrder",
              params
            ).then(res => {
              //console.log(res)
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.addOrderDialogVisible = false;
              this.queryList();
            });
          }
        });
      } else {
        //远程监测
        this.$refs.dataForm.validate(valid => {
          if (valid) {
            if (
              this.dataForm.goodId == null ||
              this.dataForm.goodId == "" ||
              this.dataForm.goodId == " "
            ) {
              this.$message({ message: "请选择商品", type: "error" });
              return;
            }
            let params = {};
            params.olamanId = this.dataForm.oldmanId;
            params.merchandiseId = this.dataForm.goodId;
            params.serviceAddress = this.dataForm.serviceAddress;
            params.remark = this.dataForm.remark;
            this.$postJson(
              "omc/longRangeServiceOrder/superviseAnOrder",
              params
            ).then(res => {
              //console.log(res)
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.addOrderDialogVisible = false;
              this.queryList();
            });
          }
        });
      }
    },

    closeDialog() {
      this.dialogVisible = false;
      this.$refs.doctorForm.resetFields();
      this.doctorForm = {};
    },

    closeAddDialog() {
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      this.dataForm = {};
    },

    /* 
      家庭地址的聚焦选择地址
    */
    focusServiceAddress() {
      this.dialogFormVisibleSafe = true;
    },

    //点击地图里面的input搜素框输入搜索，获取所有搜索的地址的数组 []
    markersset(e) {
      //console.log(e)
      //输入家庭住址时，让搜索的结果显示
      document.getElementById("bm-local-search").style.display = "block";
    },

    //点击搜索的结果，获取点击获取的地址
    infohtmlset(e) {
      console;
      //先置空
      this.dataForm.serviceAddress = "";
      //console.log(e)
      //console.log(e.address)
      //console.log(e.point)
      //把搜索选取的地址赋给外层dialog 家庭地址的input框
      this.dataForm.serviceAddress = e.address;
      this.dataForm.detailedAddress = e.address;
      this.dataForm.oldAddressBdGps = `${e.point.lng},${e.point.lat}`;
      //当选取了地址后，让其隐藏
      document.getElementById("bm-local-search").style.display = "none";
    },

    //点击地图dialog叉号关闭 重置
    closeMap() {
      //console.log('aaa')
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog ,input框自动聚焦 比较友好
      let inputelementAdd = document.getElementById("oldAddressAdd");
      if (inputelementAdd != null) {
        //判断一下 因为编辑时打开地图时此值不存在的
        inputelementAdd.focus();
      }
      let inputelement = document.getElementById("oldAddress");
      if (inputelement != null) {
        //判断一下 因为新增时打开地图时此值不存在的
        inputelement.focus();
      }
    },

    //点击地图，记住地图选取的地址，清除上次点击的位置
    sureMap() {
      this.dialogFormVisibleSafe = false;
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog,input框自动聚焦 比较友好
      let inputelementAdd = document.getElementById("oldAddressAdd");
      if (inputelementAdd != null) {
        //判断一下 因为编辑时打开地图时此值不存在的
        inputelementAdd.focus();
      }
      let inputelement = document.getElementById("oldAddress");
      if (inputelement != null) {
        //判断一下 因为新增时打开地图此值不存在的
        inputelement.focus();
      }
    },

    //生成地图实例
    handler({ BMap, map }) {
      //(BMap, map)地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例。百度地图组件是异步加载，
      //请不要尝试在组件的生命周期中访问 BMap 核心类和 map 实例，如有需要，请在所需组件的 ready 事件回调函数的参数中获取。
      //console.log(BMap, map)
      //武汉的经纬度 zoom为地图显示的比例
      this.center.lng = 114.31667;
      this.center.lat = 30.51667;
      this.zoom = 15;
      //  //获取定位的数据
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        r => {
          if (r.point) {
            //console.log(r.point)
            this.center.lng = r.longitude;
            this.center.lat = r.latitude;
            var point = new BMap.Point(this.center.lng, this.center.lat); //用当前定位的经纬度查找省市区街道等信息
            let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
            //console.log(this.center.lng)
            //console.log(this.center.lat)
            geocoder.getLocation(r.point, rs => {
              //console.log(rs.address) //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
              let markers = new BMap.Marker(r.point);
              //console.log(markers)
              // map.addOverlay(markers); //添加
              map.panTo(r.point);
              map.centerAndZoom(r.point, 15);
            });
          }
        },
        { enableHighAccuracy: true }
      );
      //by guo 2019-11-17
      window.map = map;
      // 赋值，方便调用，本节被用到
      this.BMap = BMap;
      this.map = map;
    },

    //点击获取mark
    getPoint(e) {
      //点击地图获取一些信息，
      //console.log(e)
      (this.postionHuiXian.lng = ""), //把会显得点去掉
        (this.postionHuiXian.lat = "");
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();
      // this.center.lng=e.point.lng;
      // this.center.lat=e.point.lat;
      //console.log(e.point)
      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, rs => {
        this.add.site = rs.address;
        this.dataForm.serviceAddress = rs.address;
        // this.keyword = rs.address;
        this.dataForm.oldAddressBdGps = `${e.point.lng},${e.point.lat}`;
        this.dataForm.longitude = e.point.lng;
        this.dataForm.latitude = e.point.lat;
        this.dataForm.detailedAddress = rs.address;
        //地址描述(string)=
        //console.log(rs.address) //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
        //console.log(rs.addressComponents) //结构化的地址描述(object)
        //console.log(rs.addressComponents.province) //省
        //console.log(rs.addressComponents.city) //城市
        //console.log(rs.addressComponents.district) //区县
        //console.log(rs.addressComponents.street) //街道
        //console.log(rs.addressComponents.streetNumber) //门牌号
        //console.log(rs.surroundingPois) //附近的POI点(array)
        //console.log(rs.business) //商圈字段，代表此点所属的商圈(string)
      });
      //console.log(e.point) //打印markpoint
    },

    //点击生成mark点的提示关闭
    infoWindowClose() {
      this.show = false;
    },

    //提示打开
    infoWindowOpen() {
      //这里有个问题纠结了很久，百度的信息窗口默认有个点击其他地方就消失的事件，我没有找到
      //并且信息窗口点击一次显示，一次消失
      //于是我加了一个100毫秒的定时器，保证每次点击地图都可以展示信息窗口
      setInterval(() => {
        this.show = true;
      }, 100);
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`)
      //改变每页显示的条数
      this.PageSize = val;
      this.queryList(); //刷新列表的数据
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`)
      this.pageNum = val;
      this.queryList(); //刷新列表的数据
    },

    /* 
      表格头部的样式
    */
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #CCCCCC;";
      }
    },

    // 处理下拉框滑动问题
    handleVisibleChange(visible) {
      let main = document.getElementsByClassName("el-main");
      let dropdown = document.getElementsByClassName("el-select-dropdown");
      main[0].onscroll = function(e) {
        // e.target.scrollTop 滑动高度
        for (let i = 0; i < dropdown.length; i++) {
          dropdown[i].style.display = "none";
        }
      };
    },
    //获取二级服务id
    getSecondLevellId() {
      let params = { groupId: sessionStorage.getItem("groupId") };
      this.$postJson("omc/service/listService", params).then(res => {
        console.log(res.result);
        res.result.forEach(item => {
          if (item.name == "远程看护") {
            item.serviceSecondLevelList.forEach(el => {
              if (el.secondLevelName == "远程监测") {
                console.log(el.id * 1);
                this.secondServerList[2].value = el.id * 1;
                console.log(this.secondServerList);
              }
            });
          }
        });
      });
    }
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  mounted() {
    this.queryList();
    this.getSecondLevellId();
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.demo-table-expand .el-form--inline .el-form-item__label {
  float: none;
  display: inline-block;
  color: #99a9bf;
  font-weight: 700;
}
.height40 {
  height: 40px;
  line-height: 40px;
}
.colorBtn {
  background: rgb(165, 72, 241);
  color: #fff;
}

.labelOne {
  display: inline-block;
  width: 100px;
  margin-left: 10px;
  height: 20px;
  line-height: 20px;
  text-align: left;
}
.custom-tree-node-1 {
  display: inline-block;
  margin-left: 20px;
  width: 100px;
  text-align: left;
}
.custom-tree-node-show {
  display: inline-block;
  width: 100px;
  text-align: left;
  margin-left: 50px;
}
::deep .el-tree-node__content {
  height: 40px !important;
}
::deep
  .packagemanagement-tree
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: #fff !important;
  color: #606266 !important;
  border-radius: 5px !important;
}
::deep .packagemanagement-tree .el-checkbox {
  height: 30px;
  line-height: 28px;
}
.oldmanmap {
  margin: 20px 5px;
  border: 1px solid rgb(228, 222, 222);
  .map {
    width: 100%;
    height: 400px;
  }
}
//地图插件·
::deep .BMap_stdMpCtrl {
  top: 50px !important;
}
::deep .citylist_popup_main {
  margin-left: 45px;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  // text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
::deep.el-dialog-map .el-dialog__body {
  padding: 10px !important;
}
::deep .el-dialog-map {
  .el-input__inner {
    width: 50%;
  }
}
.fenye {
  margin: 0px;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>